export default __webpack_public_path__ + "static/media/rocket_anim_157.acce5992.png";